import { TwoFactorAuthentification } from './TwoFactorAuthentification';
import { PageWrapper } from './PageWrapper';
import { UserInfo } from './UserInfo';
import { PasswordReset } from './PasswordReset/PasswordReset';
import { Button } from '@e2n/ui';

export function Page() {
  return (
    <PageWrapper>
      <UserInfo />
      <PasswordReset />
      <TwoFactorAuthentification />
      <Button>Button</Button>
    </PageWrapper>
  );
}
